var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.88,
    height: 34.88,
    viewBox: "0 0 34.88 34.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "google",
    d: "M0,17.44A17.46,17.46,0,0,1,17.44,0,17.279,17.279,0,0,1,28.071,3.614L24.018,8.878A10.692,10.692,0,0,0,17.44,6.644,10.8,10.8,0,1,0,27.713,20.762H17.44V14.118H34.88V17.44A17.44,17.44,0,0,1,0,17.44Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.01ef73a4d5a59c24b177aabd06001e06.svg";
export { ForwardRef as ReactComponent };